import React, { createContext, useCallback, useState, useMemo, useContext, useEffect } from 'react';
import { createPortal } from 'react-dom';
import { v4 as uuidv4 } from 'uuid';

import type { ReactNode } from 'react';

export interface ModalProps {
  onClose: () => void;
}

type RenderModal = ({ onClose }: ModalProps) => JSX.Element;

interface ModalContextInterface {
  openModal: (render: RenderModal) => void;
}

interface Modal {
  uuid: string;
  onClose: () => void;
  render: RenderModal;
}

export const ModalContext = createContext<ModalContextInterface>({ openModal: () => null });

export function ModalProvider({ children }: { children: ReactNode }) {
  const [modals, setModals] = useState<Modal[]>([]);

  const openModal = useCallback((render: RenderModal) => {
    const uuid = uuidv4();
    setModals((prevModals) => [
      ...prevModals,
      {
        uuid,
        render,
        onClose: () => setModals((existingModals) => existingModals.filter((modal) => modal.uuid !== uuid)),
      },
    ]);
  }, []);

  const value = useMemo(() => ({ openModal }), [openModal]);

  useEffect(() => {
    console.info(modals);
  }, [modals]);

  return (
    <ModalContext.Provider value={value}>
      {children}
      {modals.map(({ uuid, render, onClose }) =>
        createPortal(<React.Fragment key={uuid}>{render({ onClose })}</React.Fragment>, document.body),
      )}
    </ModalContext.Provider>
  );
}

export function useModal() {
  const { openModal } = useContext(ModalContext);
  return openModal;
}
